import { gql } from "@apollo/client";

export const GET_PROGRAMMING_STRUCTURE_BY_ID = gql`
  query programmingStructureById($scenarioId: ID!, $programmingStructureId: ID!) {
    cube(scenarioId: $scenarioId) {
      programmingStructure(id: $programmingStructureId) {
        id
        code
        name
        subjectCodes
        campusCodes
        source
        programmingStructureStats {
          id
          isPublished
          isVisible
        }
        programmingStructureParts {
          id
          code
          name
          blockDuration
          dependenciesCodes
          references
          programmingStructureStage {
            id
            code
            name
            programmingStructureStageType {
              id
              code
              name
            }
          }
        }
      }
    }
  }
`;
